import type { LoginUserAdminDto } from '../types/dto';
import type { LoginAdminResponse } from '../types/api';
import { baseApi } from 'sama-shared';

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    adminLogin: builder.mutation<LoginAdminResponse, LoginUserAdminDto>({
      query: (credentials) => ({
        url: '/admin/auth/login',
        method: 'POST',
        body: credentials,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useAdminLoginMutation } = authApi;
